var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompetetionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#1E3A51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6757 7.09989C13.2658 6.08291 14.7344 6.08291 15.3245 7.0999L17.1317 10.2143C17.2983 10.5014 17.5862 10.6973 17.9144 10.7469L20.9153 11.2001C22.2234 11.3977 22.6823 13.0493 21.6635 13.8934L19.477 15.7049C19.1701 15.9591 19.0258 16.3602 19.1003 16.7517L19.7128 19.9682C19.9528 21.2282 18.6301 22.2071 17.4952 21.6095L14.5097 20.0375C14.1907 19.8696 13.8095 19.8696 13.4905 20.0375L10.505 21.6095C9.37008 22.2071 8.04741 21.2282 8.28733 19.9682L8.89982 16.7517C8.97437 16.3602 8.83007 15.9591 8.52317 15.7049L6.33663 13.8934C5.31788 13.0493 5.77673 11.3977 7.08485 11.2001L10.0858 10.7469C10.414 10.6973 10.7019 10.5014 10.8685 10.2143L12.6757 7.09989ZM14.1893 7.75862C14.105 7.61334 13.8952 7.61334 13.8109 7.75862L12.0037 10.8731C11.6372 11.5046 11.0038 11.9356 10.2818 12.0447L7.28087 12.4979C7.09399 12.5261 7.02844 12.7621 7.17398 12.8827L9.36051 14.6942C10.0357 15.2536 10.3532 16.1359 10.1892 16.9972L9.57667 20.2137C9.54239 20.3937 9.73134 20.5336 9.89347 20.4482L12.879 18.8762C13.5807 18.5067 14.4194 18.5067 15.1212 18.8762L18.1067 20.4482C18.2688 20.5336 18.4578 20.3937 18.4235 20.2137L17.811 16.9972C17.647 16.1359 17.9645 15.2536 18.6396 14.6942L20.8262 12.8827C20.9717 12.7621 20.9062 12.5261 20.7193 12.4979L17.7184 12.0447C16.9964 11.9356 16.3629 11.5046 15.9965 10.8731L14.1893 7.75862Z",
    fill: "#3EAFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetetionicon);
export default __webpack_public_path__ + "static/media/competetionicon.3497ffe839b80dab474378a689fe0b2e.svg";
export { ForwardRef as ReactComponent };